import { render, staticRenderFns } from "./productionDialog.vue?vue&type=template&id=55365f77&scoped=true"
import script from "./productionDialog.vue?vue&type=script&lang=js"
export * from "./productionDialog.vue?vue&type=script&lang=js"
import style0 from "./productionDialog.vue?vue&type=style&index=0&id=55365f77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55365f77",
  null
  
)

export default component.exports